import Vue from 'vue';
import VueI18n from 'vue-i18n';
import config from '_config';
import { fetchModulesLocales } from '_utils/require';

import pt from './locale/pt';
import es from './locale/es';
import en from './locale/en';

Vue.use(VueI18n);

const modulesLocales = fetchModulesLocales(
  require.context('_modules', true, /locale\/.*\.js$/),
);

export default new VueI18n({
  locale: config.LOCALE,
  fallbackLocale: 'pt',
  messages: {
    pt: {
      ...pt,
      ...modulesLocales.pt,
    },
    es: {
      ...es,
      ...modulesLocales.es,
    },
    en: {
      ...en,
      ...modulesLocales.en,
    },
  },
});
